module.exports = __webpack_public_path__ + "assets/img/chef-11.7826cd3b.jpg";